import React from 'react';
import { toast } from 'sonner';
import { CheckCircle2, Dumbbell } from 'lucide-react';
import { Card, LockedNotice, Pill, SectionHeader } from './ui';
import { PROGRAM_NAMES, STATE_META, studentApi } from '../../pages/journey/journeyApi';

const Extras = ({ extras, studentId, refresh }) => {
  const open = extras.filter((x) => !x.done);
  if (!extras.length) return null;
  const done = (id) => studentApi(`/me/extras/${id}/done?student_id=${studentId}`, { method: 'POST' }).then(() => { toast.success('Marked done'); refresh(); });
  return (
    <Card className="mb-5 border-amber-200 bg-amber-50/40" data-testid="extra-practice">
      <p className="font-outfit font-semibold text-[#0b1f4d] mb-3 flex items-center gap-2"><Dumbbell className="w-4 h-4 text-amber-600" /> Additional practice ({open.length} open)</p>
      {extras.map((x) => (
        <div key={x.id} className="flex items-start justify-between gap-4 py-3 border-t border-amber-100 first:border-0" data-testid={`extra-${x.id}`}>
          <div><p className={`text-sm font-medium ${x.done ? 'line-through text-slate-400' : ''}`}>{x.title}</p><p className="text-xs text-slate-600">{x.text}</p>
            <p className="text-[11px] text-slate-400 mt-1">Assigned by {x.source}</p></div>
          {!x.done ? <button onClick={() => done(x.id)} className="text-xs font-semibold text-teal-700 shrink-0" data-testid={`extra-done-${x.id}`}>Mark done</button>
            : <CheckCircle2 className="w-4 h-4 text-teal-600 shrink-0" />}
        </div>))}
    </Card>
  );
};

export const Assignments = ({ data: d, openMission, studentId, refresh }) => {
  const items = d.pathways.flatMap((pw) => pw.items.filter((i) => i.state !== 'locked').map((i) => ({ ...i, program_id: pw.program_id })));
  return (
    <>
      <SectionHeader eyebrow="Create · practise · revise · demonstrate" title="Practical Assignments" />
      {!d.entitlements.length ? <LockedNotice testid="assignments-locked" title="Assignments unlock after enrollment" text="Each purchased program unlocks its own practical missions and diagnostics." /> : (<>
        <Extras extras={d.extras} studentId={studentId} refresh={refresh} />
        <div className="grid md:grid-cols-2 gap-4">
          {items.map((i) => (
            <Card key={i.mission.id} className="cursor-pointer hover:border-teal-400 transition-colors" onClick={() => openMission(i.mission.id)} data-testid={`assignment-card-${i.mission.id}`}>
              <div className="flex justify-between gap-2 mb-2"><span className="text-xs text-slate-500">{PROGRAM_NAMES[i.program_id]}</span><Pill className={STATE_META[i.state].cls}>{STATE_META[i.state].label}</Pill></div>
              <p className="font-medium text-[#0b1f4d]">{i.mission.title}</p>
              <p className="text-xs text-slate-500 mt-1">{i.attempts.length} attempt(s){i.attempts.length > 1 ? ` · ${i.attempts.map((a) => a.score ?? '…').join('% → ')}%` : ''}</p>
            </Card>))}
        </div>
      </>)}
    </>
  );
};
